import React from 'react';

import classes from './AuthPage.module.css';

const AuthPage = ({ onLogin, onRegister }) => {
  return (
    <div className={classes.pageContainer}>
      <div className={classes.card}>
        <h1 className={classes.title}>Device Platform</h1>
        <p className={classes.subtitle}>device.allorado.io</p>
        <p className={classes.message}>Please login or register to continue</p>
        <div className={classes.buttons}>
          <button
            onClick={onLogin}
            className={`${classes.button} ${classes.login}`}
          >
            Login
          </button>
          <button
            onClick={onRegister}
            className={`${classes.button} ${classes.register}`}
          >
            Register
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;


